import React, {useState} from 'react';
import {
  OpenEndedQuestionAnswer,
  OpenEndedQuestionContent,
} from '../../../../data/models/LessonContent/LessonContentBase';
import Button from '../../../../uiToolkit/Buttons/Button';
import ChallengeInfoHeader from '../ChallengeInfoHeader/ChallengeInfoHeader';
import {tapyblPlayerText} from '../../tapyblPlayerText';
import TextAreaInput from '../../../../uiToolkit/Inputs/TextAreaInput';
import './styles.css';
import FilePickerInput from '../../../../uiToolkit/Inputs/FilePickerInput';

interface Props {
  question: OpenEndedQuestionContent;
  onSelectChoice: (answer: OpenEndedQuestionAnswer) => void;
  passingScore?: number;
}

const OpenEndedQuestionOverlay = React.memo(
  ({question, onSelectChoice, passingScore}: Props) => {
    const [selectedAnswerText, setSelectedAnswerText] = useState('');
    const [selectedAnswerFile, setSelectedAnswerFile] = useState<
      File | undefined
    >(undefined);

    const onContinueClick = () => {
      const selectedAnswer: OpenEndedQuestionAnswer = {
        textAreaValue: selectedAnswerText,
        attachmentValue: selectedAnswerFile,
      } as OpenEndedQuestionAnswer;
      onSelectChoice(selectedAnswer);
      setSelectedAnswerText('');
      setSelectedAnswerFile(undefined);
    };

    return (
      <div className="OpenEndedQuestionOverlay">
        <ChallengeInfoHeader
          passingScore={passingScore}
          //typeIcon="icon-typeMultiple-choice"
          typeIcon="open-ended-question-icon.svg"
          typeTitle={tapyblPlayerText.openEndedQuestion}
          haveMultipleAnswers={
            selectedAnswerText.length > 0 && selectedAnswerFile !== undefined
          }
          isGradable
          className="OpenEndedQuestionHeader"
        />
        <div className="Content">
          {question.textAreaAnswerEnabled && (
            <>
              <p className="Prompt">{question.textAreaAnswerPrompt}</p>
              <div>
                <TextAreaInput
                  value={selectedAnswerText}
                  onChange={setSelectedAnswerText}
                  placeholder={''}
                  className="textAreaAnswerInput"
                  maxCharacters={question.textAreaAnswerMaxCharacterCount}
                  maxHeight={110}
                />
              </div>
            </>
          )}
          {question.attachmentAnswerEnabled && (
            <>
              <p className="Prompt">{question.attachmentAnswerPrompt}</p>
              <div>
                <FilePickerInput
                  onChange={setSelectedAnswerFile}
                  file={selectedAnswerFile}
                  placeholder={question.attachmentAnswerFileTypes.join(', ')}
                  className="attachmentAnswerInput"
                  acceptFileTypes={question.attachmentAnswerFileTypes.join(
                    ', ',
                  )}
                />
              </div>
            </>
          )}
          <Button
            title={tapyblPlayerText.continue}
            onClick={onContinueClick}
            className="AnswersSubmit"
            disabled={
              selectedAnswerText.length == 0 && selectedAnswerFile === undefined
            }
            uiType="secondary"
          />
        </div>
      </div>
    );
  },
);

export default OpenEndedQuestionOverlay;
